import { render, staticRenderFns } from "./CommitmentCarrierMaterial.vue?vue&type=template&id=1209a35b"
import script from "./CommitmentCarrierMaterial.vue?vue&type=script&lang=js"
export * from "./CommitmentCarrierMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports